import { store } from '../../../../redux/store';

const DOCUMENT = 'OTHER_PAYOUTS_';

const actions = {
  ADD_PAYOUT: DOCUMENT + 'ADD_PAYOUT',
  APPLY_OTHER_PAYOUTS: DOCUMENT + 'APPLY_OTHER_PAYOUTS',
  CHANGE_PAYOUT_VALUE: DOCUMENT + 'CHANGE_PAYOUT_VALUE',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  DELETE_PAYOUT: DOCUMENT + 'DELETE_PAYOUT',
  FILL_COLUMN: DOCUMENT + 'FILL_COLUMN',
  LOAD_DATA: DOCUMENT + 'LOAD_DATA',
  LOAD_DATA_SUCCESS: DOCUMENT + 'LOAD_DATA_SUCCESS',

  addPayout: payload => ({ type: actions.ADD_PAYOUT, payload, startAppSettings: store.getState().StartAppSettings }),

  applyOtherPayouts: payload => ({ type: actions.APPLY_OTHER_PAYOUTS, payload }),

  changePayoutValue: payload => ({
    type: actions.CHANGE_PAYOUT_VALUE,
    payload,
    startAppSettings: store.getState().StartAppSettings,
  }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),

  deletePayout: payload => ({
    type: actions.DELETE_PAYOUT,
    payload,
    startAppSettings: store.getState().StartAppSettings,
  }),

  fillColumn: payload => ({ type: actions.FILL_COLUMN, payload, startAppSettings: store.getState().StartAppSettings }),

  loadData: payload => ({ type: actions.LOAD_DATA, payload }),

  loadDataSuccess: payload => ({
    type: actions.LOAD_DATA_SUCCESS,
    payload,
    startAppSettings: store.getState().StartAppSettings,
  }),
};

export default actions;
